import type { ExternalTableSchema } from '@packages/table-builder';

export const rolePublishTable: ExternalTableSchema = {
  metadata: {
    title: 'Role Publish',
    entity: 'RolePublish',
    description: 'Publish roles to destination companies.',
  },

  dataSource: {
    endpoint: '/api/customer/api/v2/customer/customer-success/roles/published',
    method: 'GET',
    rowIdField: 'publishId',
    itemsTransformId: 'role-publish',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      DestinationCompanyId: 'filters.companyName',
      SourceRoleId: 'filters.roleName',
    },
    filters: [
      {
        name: 'companyName',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/customer/customer-success/options/allowed-destination-companies',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'roleName',
        placeholder: 'Role',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/customer/customer-success/options/self-roles',
          labelField: 'name',
          // Legacy ROLE_PUBLISH_TABLE server schema mapper.value === 'id' → SourceRoleId query param
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'roleName',
      header: 'Source Role',
      type: 'text',
      width: 280,
      align: 'left',
    },
    {
      field: 'companyName',
      header: 'Destination Company',
      type: 'text',
      width: 150,
      align: 'left',
    },
  ],

  actions: {
    // Group-by: menu on group header only (legacy RolePublishHeader hideOnSubRows: true).
    row: [
      { id: 'VIEW_ROLE_PUBLISH', label: 'View' },
      { id: 'EDIT_ROLE_PUBLISH', label: 'Edit' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_ROLE_PUBLISH',
        label: 'Role Publish',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    filterGrid: { columns: 2 },
    pagination: { mode: 'none', defaultSize: 10 },
    groupBy: {
      fields: ['roleName'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
    },
  },
};
